module.exports = __webpack_public_path__ + "static/media/07_hero_mobile.dfb0bceb.jpg";